import * as BABYLON from 'babylonjs';
import { Mesh, Vector3 } from 'babylonjs';
import * as GUI from 'babylonjs-gui';
import { Room } from "colyseus.js";
import { IAgoraRTCClient, IMicrophoneAudioTrack } from "agora-rtc-sdk-ng";
import * as AgoraRTC from "agora-rtc-sdk-ng";
import 'babylonjs-loaders';

import { getStyle, Style } from './styles';
import { createSkyBox } from "./utils";
import { AdvancedDynamicTexture } from 'babylonjs-gui';
import { getIpfsMetadata, ipfsPrefix, nextFxhash, Metadata } from './profiles'

const GROUND_SIZE = 1000;
const GROUND_BOUNDS = GROUND_SIZE / 2 - 10;
var iframeFocused = false;

var setupRenderer = function () {
    let container = document.createElement('div')
    container.id = 'css-container'
    container.style.position = 'absolute'
    container.style.width = '100%'
    container.style.height = '100%'
    container.style.zIndex = '-1'

    let canvasZone = document.getElementById('renderCanvas')
    console.log('canvaszone', canvasZone)
    document.body.insertBefore(container, document.body.firstChild);

    let renderer = new CSS3DRenderer()
    container.appendChild(renderer.domElement)
    renderer.setSize(canvasZone.offsetWidth, canvasZone.offsetHeight)

    window.addEventListener('resize', e => {
        renderer.setSize(canvasZone.offsetWidth, canvasZone.offsetHeight)
    })
    return renderer
}

class CSS3DObject extends BABYLON.Mesh {
    element: any;
    constructor(element, scene) {
        super(scene)
        this.element = element
		this.element.style.position = 'absolute'
		this.element.style.pointerEvents = 'auto'
    }
}

var setIframeSrc = (url: string) => {
    const iframe = document.getElementById("iframe-main") as HTMLIFrameElement;
    if (iframe)
        iframe.src = url;
}

var createCSSobject = function(mesh: Mesh, scene, renderer, width, height) {
    scene.onBeforeRenderObservable.add(() => {
        renderer.render(scene, scene.activeCamera)
    })
    var div = document.createElement( 'div' )
    div.style.width = width + 'px'
    div.style.height = height + 'px'
    div.style.backgroundColor = '#000'
    div.style.zIndex = '1'
    var CSSobject = new CSS3DObject(div, scene)
    var pos = mesh.getAbsolutePosition();
    console.log('abspos', pos)
    CSSobject.position.copyFrom(pos)
    CSSobject.rotation.y = -mesh.rotation.y
    let scaling = mesh.scaling;
    console.log('scaling', scaling)
    //scaling.x *= 10;
    //scaling.y *= 10;
    CSSobject.scaling.copyFrom(scaling)

    var iframe = document.createElement( 'iframe' )
    iframe.id = 'iframe-main'
    iframe.style.width = width + 'px'
    iframe.style.height = height + 'px'
    iframe.style.border = '0px'
    iframe.allow = 'autoplay'
    div.appendChild(iframe)
    console.log('append iframe', iframe)

    // Another new bit that toggles on/off pointer events to body
    div.addEventListener('mouseout', () => {
        iframeFocused = false
        console.log("CANVAS")
        document.getElementsByTagName('body')[0].style.pointerEvents = 'auto'
    })
}

function createMaskingScreen(maskMesh, scene, engine) {
    let depthMask = new BABYLON.StandardMaterial('matDepthMask', scene)
    depthMask.backFaceCulling = false

    maskMesh.material = depthMask
    maskMesh.onBeforeRenderObservable.add(() => engine.setColorWrite(false))
    maskMesh.onAfterRenderObservable.add(() => engine.setColorWrite(true))

    // swap meshes to put mask first
    var mask_index = scene.meshes.indexOf(maskMesh)
    scene.meshes[mask_index] = scene.meshes[0]
    scene.meshes[0] = maskMesh
}

const navbar = '250px';
class CSS3DRenderer {
    cache: any;
    domElement: any;
    cameraElement: any;
    isIE: boolean;
    width: number;
    height: number;
    widthHalf: number;
    heightHalf: number;

    constructor() {
		var matrix = new BABYLON.Matrix()

		this.cache = {
			camera: { fov: 0, style: '' },
			objects: new WeakMap()
		}

		var domElement = document.createElement( 'div' )
        domElement.style.overflow = 'hidden'
        domElement.style.marginRight = navbar;

		this.domElement = domElement
		this.cameraElement = document.createElement( 'div' )
		this.isIE = (!!document['documentMode'] || /Edge/.test(navigator.userAgent) || /Edg/.test(navigator.userAgent))

		if (!this.isIE) {
			this.cameraElement.style.webkitTransformStyle = 'preserve-3d'
			this.cameraElement.style.transformStyle = 'preserve-3d'
		}
		this.cameraElement.style.pointerEvents = 'none'

		domElement.appendChild(this.cameraElement)
    }

    getSize() {
		return {
			width: this.width,
			height: this.height
		}
    }

	setSize(width, height) {
		this.width = width
		this.height = height
		this.widthHalf = this.width / 2
		this.heightHalf = this.height / 2

		this.domElement.style.width = width + 'px'
		this.domElement.style.height = height + 'px'

		this.cameraElement.style.width = width + 'px'
		this.cameraElement.style.height = height + 'px'
	}    

	epsilon(value) {
		return Math.abs(value) < 1e-10 ? 0 : value
	}

	getCameraCSSMatrix(matrix) {
		var elements = matrix.m

		return 'matrix3d(' +
			this.epsilon( elements[ 0 ] ) + ',' +
			this.epsilon( - elements[ 1 ] ) + ',' +
			this.epsilon( elements[ 2 ] ) + ',' +
			this.epsilon( elements[ 3 ] ) + ',' +
			this.epsilon( elements[ 4 ] ) + ',' +
			this.epsilon( - elements[ 5 ] ) + ',' +
			this.epsilon( elements[ 6 ] ) + ',' +
			this.epsilon( elements[ 7 ] ) + ',' +
			this.epsilon( elements[ 8 ] ) + ',' +
			this.epsilon( - elements[ 9 ] ) + ',' +
			this.epsilon( elements[ 10 ] ) + ',' +
			this.epsilon( elements[ 11 ] ) + ',' +
			this.epsilon( elements[ 12 ] ) + ',' +
			this.epsilon( - elements[ 13 ] ) + ',' +
			this.epsilon( elements[ 14 ] ) + ',' +
			this.epsilon( elements[ 15 ] ) +
		')'
	}    

	getObjectCSSMatrix(matrix, cameraCSSMatrix) {
		var elements = matrix.m;
		var matrix3d = 'matrix3d(' +
			this.epsilon( elements[ 0 ] ) + ',' +
			this.epsilon( elements[ 1 ] ) + ',' +
			this.epsilon( elements[ 2 ] ) + ',' +
			this.epsilon( elements[ 3 ] ) + ',' +
			this.epsilon( - elements[ 4 ] ) + ',' +
			this.epsilon( - elements[ 5 ] ) + ',' +
			this.epsilon( - elements[ 6 ] ) + ',' +
			this.epsilon( - elements[ 7 ] ) + ',' +
			this.epsilon( elements[ 8 ] ) + ',' +
			this.epsilon( elements[ 9 ] ) + ',' +
			this.epsilon( elements[ 10 ] ) + ',' +
			this.epsilon( elements[ 11 ] ) + ',' +
			this.epsilon( elements[ 12 ] ) + ',' +
			this.epsilon( elements[ 13 ] ) + ',' +
			this.epsilon( elements[ 14 ] ) + ',' +
			this.epsilon( elements[ 15 ] ) +
		')'

		if (this.isIE) {
			return 'translate(-50%,-50%)' +
				'translate(' + this.widthHalf + 'px,' + this.heightHalf + 'px)' +
				cameraCSSMatrix +
				matrix3d;
		}
		return `translate(-50%,-50%)`  + matrix3d
	}    

	renderObject(object, scene, camera, cameraCSSMatrix ) {
        if (object instanceof CSS3DObject) {
            var style
			var objectMatrixWorld = object.getWorldMatrix().clone()
			var camMatrix = camera.getWorldMatrix()
            var innerMatrix = [...objectMatrixWorld.m];

			// Set scaling
			const youtubeVideoWidth = 1.85
			const youtubeVideoHeight = 1.85

			innerMatrix[0] *= 1 / youtubeVideoWidth
			innerMatrix[2] *= 1 / youtubeVideoWidth
			innerMatrix[5] *= 1 / youtubeVideoHeight

			// Set position from camera
            innerMatrix[12] = -camMatrix.m[12] + object.position.x;
			innerMatrix[13] = -camMatrix.m[13] + object.position.y
			innerMatrix[14] = camMatrix.m[14] - object.position.z
            innerMatrix[15] = camMatrix.m[15] * 0.000001

			objectMatrixWorld = BABYLON.Matrix.FromArray(innerMatrix)
            objectMatrixWorld = objectMatrixWorld.scale(100)
			style = this.getObjectCSSMatrix( objectMatrixWorld, cameraCSSMatrix)
            var element = object.element
            var cachedObject = this.cache.objects.get( object )

            if ( cachedObject === undefined || cachedObject.style !== style ) {

                element.style.webkitTransform = style
                element.style.transform = style

                var objectData = { style: style }

                this.cache.objects.set( object, objectData )
            }
            if ( element.parentNode !== this.cameraElement ) {
                this.cameraElement.appendChild( element )
            }

        } else if ( object instanceof BABYLON.Scene ) {
            for ( var i = 0, l = object.meshes.length; i < l; i ++ ) {
                this.renderObject( object.meshes[ i ], scene, camera, cameraCSSMatrix )
            }
        }
	}    

	render(scene, camera) {
        var projectionMatrix = camera.getProjectionMatrix()
		var fov = projectionMatrix.m[5] * this.heightHalf

		if (this.cache.camera.fov !== fov) {

			if (camera.mode == BABYLON.Camera.PERSPECTIVE_CAMERA ) {
				this.domElement.style.webkitPerspective = fov + 'px'
				this.domElement.style.perspective = fov + 'px'
			} else {
				this.domElement.style.webkitPerspective = ''
				this.domElement.style.perspective = ''
			}
			this.cache.camera.fov = fov
		}

		if ( camera.parent === null ) camera.computeWorldMatrix()

		var matrixWorld = camera.getWorldMatrix().clone()
		var rotation = matrixWorld.clone().getRotationMatrix().transpose()
		var innerMatrix = matrixWorld.m

		innerMatrix[1] = rotation.m[1]
		innerMatrix[2] = -rotation.m[2]
		innerMatrix[4] = -rotation.m[4]
		innerMatrix[6] = -rotation.m[6]
		innerMatrix[8] = -rotation.m[8]
		innerMatrix[9] = -rotation.m[9]

		matrixWorld = BABYLON.Matrix.FromArray(innerMatrix)

		var cameraCSSMatrix = 'translateZ(' + fov + 'px)' + this.getCameraCSSMatrix( matrixWorld )

		var style = cameraCSSMatrix + 'translate(' + this.widthHalf + 'px,' + this.heightHalf + 'px)'

		if (this.cache.camera.style !== style && !this.isIE ) {
			this.cameraElement.style.webkitTransform = style
			this.cameraElement.style.transform = style
			this.cache.camera.style = style
		}

        this.renderObject(scene, scene, camera, cameraCSSMatrix )
	}    
}

export default class Game {
    private canvas: HTMLCanvasElement;
    private engine: BABYLON.Engine;
    private scene: BABYLON.Scene;
    private camera: BABYLON.ArcRotateCamera;
    private light: BABYLON.Light;
    private yoffset = 235;
    private url: string;
    private iframeBase: string;
    private fps: GUI.TextBlock;
    private playerInfo: GUI.TextBlock;

    private room: Room<any>;
    private client: IAgoraRTCClient;
    private appid = "0e1ac6e25af748e8a208a3002775ed79";
    private localAudioTrack: IMicrophoneAudioTrack;
    private playerEntities: { [playerId: string]: BABYLON.Mesh } = {};
    private playerNextPosition: { [playerId: string]: BABYLON.Vector3 } = {};
    private advancedTexture: AdvancedDynamicTexture;
    private style: Style = getStyle();

    constructor(canvas: HTMLCanvasElement, engine: BABYLON.Engine, room: Room<any>) {
        this.canvas = canvas;
        this.engine = engine;
        this.room = room;
    }

    initAudio(): void {
        try {
            this.client = (AgoraRTC as any).createClient({ mode: "rtc", codec: "vp8" });
            // Listen for the "user-published" event, from which you can get an AgoraRTCRemoteUser object.
            this.client.on("user-published", async (user, mediaType) => {
                // Subscribe to the remote user when the SDK triggers the "user-published" event
                await this.client.subscribe(user, mediaType);
                console.log("subscribe success");

                // If the remote user publishes an audio track.
                if (mediaType === "audio") {
                    // Get the RemoteAudioTrack object in the AgoraRTCRemoteUser object.
                    const remoteAudioTrack = user.audioTrack;
                    // Play the remote audio track.
                    remoteAudioTrack.play();
                }

                // Listen for the "user-unpublished" event
                this.client.on("user-unpublished", async (user) => {
                    // Unsubscribe from the tracks of the remote user.
                    await this.client.unsubscribe(user);
                });

            });
        } catch (e) {
            console.log('initAudio failed', e)
        }
    }

    async joinAudio(agoraChannel: string, agoraToken: string): Promise<void> {
        // Join an RTC channel.
        await this.client.join(this.appid, agoraChannel, agoraToken, this.room.sessionId);
        // Create a local audio track from the audio sampled by a microphone.
        this.localAudioTrack = await (AgoraRTC as any).createMicrophoneAudioTrack();
        // Publish the local audio tracks to the RTC channel.
        await this.client.publish([this.localAudioTrack]);
        console.log("publish success!");
    }
    
    async leaveAudio(): Promise<void> {
        try {
            if (this.localAudioTrack)
                this.localAudioTrack.close();
            await this.client.leave();
        } catch (e) {

        }
    }

    async setIframeSrc() {
        if (this.url) {
            setIframeSrc(this.url)
        }
    }

    initPlayers(): void {
        this.room.state.artwork.onChange(async (artwork) => {
            const obj = this.room.state.artwork;
            console.log('artwork onchange', obj)
            const metadataHash = obj.ipfs;
            console.log('metadataHash', obj.ipfs)
            const meta = await getIpfsMetadata(metadataHash)
            console.log('meta', meta)
            const generator = meta.generatorUri || meta.artifactUri
            const base = `${ipfsPrefix}/${generator.substring(7)}/?fxhash=`;
            const hash = obj.fxhash || meta.iterationHash || nextFxhash()
            this.url = `${base}${hash}`;
            console.log('url', this.url)
            this.setIframeSrc()
            this.displayFxhash(meta);
        });

        this.room.state.world.onChange(async (world) => {
            this.playerInfo.text = `Room name: ${this.room.state.world.title}`;
        });

        this.room.state.players.onAdd((player, sessionId) => {
            const isCurrentPlayer = (sessionId === this.room.sessionId);
            console.log('adding player', player)
            const inroomselect = document.getElementsByClassName('select-inroom')[0] as HTMLSelectElement;
            const option = document.createElement("OPTION") as HTMLOptionElement;
            option.value = player.address;
            option.text = player.address;
            inroomselect.add(option)
            const sphere = BABYLON.MeshBuilder.CreateSphere(`player-${sessionId}`, {
                segments: 8,
                diameter: 40
            }, this.scene);

            // Set player mesh properties
            const sphereMaterial = new BABYLON.StandardMaterial(`playerMat-${sessionId}`, this.scene);
           	sphereMaterial.backFaceCulling = true;
            let hdrTexture = new BABYLON.HDRCubeTexture(`./public/textures/${this.style.reflection}.hdr`, this.scene, 512);
            hdrTexture.rotationY = this.style.playerRotation;
            sphereMaterial.reflectionTexture = hdrTexture;
            sphereMaterial.reflectionTexture.coordinatesMode = BABYLON.Texture.CUBIC_MODE;
            sphereMaterial.reflectionTexture.level = this.style.reflectionLevel;
	        sphereMaterial.diffuseColor = new BABYLON.Color3(0, 0, 0);
	        sphereMaterial.specularColor = new BABYLON.Color3(0, 0, 0);
            sphereMaterial.emissiveColor = (isCurrentPlayer) ? BABYLON.Color3.FromHexString("#444400") : BABYLON.Color3.Black();
            sphere.material = sphereMaterial;

            // Set player spawning position
            sphere.position.set(player.x, player.y, player.z);

            this.playerEntities[sessionId] = sphere;
            this.playerNextPosition[sessionId] = sphere.position.clone();

            // update local target position
            player.onChange(() => {
                console.log('player onchange', player)
                this.playerNextPosition[sessionId].set(player.x, player.y, player.z);
            });

            if (isCurrentPlayer) {
                //this.joinAudio(player.agoraChannel, player.agoraToken);
            }

            const ipfs = document.getElementsByClassName('input-artwork')[0] as HTMLInputElement;
            const load = document.getElementsByClassName("button-load-ipfs")[0] as HTMLButtonElement;
            load.onclick = (e) => {
                const qipfs = ipfs.value;
                if (qipfs && qipfs.length > 0) {
                    this.room.send("ipfsChanged", {
                        ipfs: qipfs,
                        fxhash: '',
                    });
                }
            }
            const next = document.getElementsByClassName("button-variation")[0] as HTMLButtonElement;
            next.onclick = (e) => {
                this.room.send("fxhashChanged", {
                    fxhash: nextFxhash(),
                });
            }
        });

        this.room.state.players.onRemove((player, playerId) => {
            console.log('onRemove', player.address)
            let i = 0;
            const inroomselect = document.getElementsByClassName('select-inroom')[0] as HTMLSelectElement;
            for (let opt of inroomselect.options) {
                if (opt.value === player.address) {
                    inroomselect.remove(i);
                    break;
                }
                i++;
            }
            this.playerEntities[playerId].dispose();
            delete this.playerEntities[playerId];
            delete this.playerNextPosition[playerId];
        });

        // this.room.state.players.onError(code => {
        //     console.log('players on error', code)
        // })

        this.room.onLeave(async code => {
            console.log('onLeave ', code)
            if (code === 1000)
               await this.gotoMenu();
        })

        this.room.onError(code => {
            console.log('room error: ', code)
        })
    }

    createGround(): void {
        // Create ground plane
        const plane = BABYLON.MeshBuilder.CreatePlane("plane", { size: GROUND_SIZE }, this.scene);
        plane.position.y = -15 - this.yoffset;
        plane.rotation.x = Math.PI / 2;

        let materialPlane = new BABYLON.PBRMaterial('floorTexturePlane', this.scene);
        materialPlane.albedoTexture = new BABYLON.Texture(`./public/textures/${this.style.ground}_Albedo.jpg`, this.scene);
        materialPlane.ambientTexture = new BABYLON.Texture(`./public/textures/${this.style.ground}_AO.jpg`, this.scene);
        materialPlane.bumpTexture = new BABYLON.Texture(`./public/textures/${this.style.ground}_Normal.jpg`, this.scene);
        materialPlane.microSurfaceTexture = new BABYLON.Texture(`./public/textures/${this.style.ground}_Roughness.jpg`, this.scene);
        let hdrTexture = new BABYLON.HDRCubeTexture(`./public/textures/${this.style.reflection}.hdr`, this.scene, 512);
        hdrTexture.rotationY = this.style.groundRotation;
        materialPlane.reflectionTexture = hdrTexture;
        materialPlane.reflectionTexture.level = this.style.reflectionLevel;
        materialPlane.metallic = 0;
        materialPlane.forceIrradianceInFragment = true;

        const yoffset = this.yoffset;

        BABYLON.SceneLoader.ImportMesh(null, "./public/", "wooden_crate_02_1k.gltf", this.scene, function (meshes) {
            for (var mesh of meshes) {
                if (mesh.name == "__root__") {
                    mesh.scaling.x = 100;
                    mesh.scaling.y = 100;
                    mesh.scaling.z = 100;
                    mesh.rotation = new BABYLON.Vector3(0, Math.PI / 4, 0)
                    mesh.position.y -= yoffset + 15;
                    mesh.position.x += 420;
                    mesh.position.z -= 450;
                }
            }
        });

        BABYLON.SceneLoader.ImportMesh(null, "./public/", "GothicCabinet_01_1k.gltf", this.scene, function (meshes) {
            for (var mesh of meshes) {
                if (mesh.name == "__root__") {
                    mesh.scaling.x = 100;
                    mesh.scaling.y = 100;
                    mesh.scaling.z = 100;
                    mesh.rotation = new BABYLON.Vector3(0, Math.PI / 4, 0)
                    mesh.position.y -= yoffset + 15;
                    mesh.position.x -= 400;
                    mesh.position.z -= 410;
                }
            }
        });

        BABYLON.SceneLoader.ImportMesh(null, "./public/", "Sofa_01_1k.gltf", this.scene, function (meshes) {
            for (var mesh of meshes) {
                if (mesh.name == "__root__") {
                    mesh.scaling.x = 150;
                    mesh.scaling.y = 150;
                    mesh.scaling.z = 150;
                    //mesh.rotation = new BABYLON.Vector3(0, Math.PI / 4, 0)
                    mesh.position.y -= yoffset + 15;
                    mesh.position.z -= 50;
                }
            }
        });

        BABYLON.SceneLoader.ImportMesh(null, "./public/", "ClassicConsole_01_1k.gltf", this.scene, function (meshes) {
            for (var mesh of meshes) {
                if (mesh.name == "__root__") {
                    mesh.scaling.x = 100;
                    mesh.scaling.y = 100;
                    mesh.scaling.z = 100;
                    mesh.position.y -= yoffset + 15;
                    mesh.position.z += 400;
                }
            }
        });

        BABYLON.SceneLoader.ImportMesh(null, "./public/", "antique_ceramic_vase_01_1k.gltf", this.scene, function (meshes) {
            for (var mesh of meshes) {
                if (mesh.name == "__root__") {
                    mesh.scaling.x = 100;
                    mesh.scaling.y = 100;
                    mesh.scaling.z = 100;
                    mesh.position.y -= yoffset - 75;
                    mesh.position.x -= 40;
                    mesh.position.z += 400;
                }
            }
        });

        plane.material = materialPlane;
    }

    displayFxhash(meta: Metadata) {
        const fxhashName = new GUI.TextBlock("fxhashName");
        fxhashName.text = `Artwork: ${meta.name}`;
        fxhashName.color = this.style.colorText;
        fxhashName.fontFamily = "Roboto";
        fxhashName.fontSize = 25;
        fxhashName.fontWeight = 'bold';
        fxhashName.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        fxhashName.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        fxhashName.paddingTop = "50px";
        fxhashName.paddingLeft = "10px";
        fxhashName.outlineColor = "#000000";
        this.advancedTexture.addControl(fxhashName);
    }

    displayGameControls() {
        this.advancedTexture = GUI.AdvancedDynamicTexture.CreateFullscreenUI("textUI");

        this.playerInfo = new GUI.TextBlock("playerInfo");
        console.log('room', this.room);
        this.playerInfo.text = `Room name: ${this.room.name}`;
        this.playerInfo.color = this.style.colorText;
        this.playerInfo.fontFamily = "Roboto";
        this.playerInfo.fontSize = 25;
        this.playerInfo.fontWeight = 'bold';
        this.playerInfo.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        this.playerInfo.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        this.playerInfo.paddingTop = "10px";
        this.playerInfo.paddingLeft = "10px";
        this.playerInfo.outlineColor = "#000000";
        this.advancedTexture.addControl(this.playerInfo);

        this.fps = new GUI.TextBlock("playerInfo");
        this.fps.text = `FPS: 44`;
        this.fps.color = this.style.colorText;
        this.fps.fontFamily = "Roboto";
        this.fps.fontSize = 25;
        this.fps.fontWeight = 'bold';
        this.fps.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        this.fps.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        this.fps.paddingTop = "90px";
        this.fps.paddingLeft = "10px";
        this.fps.outlineColor = "#000000";
        this.advancedTexture.addControl(this.fps);

        const instructions = new GUI.TextBlock("instructions");
        instructions.text = "CLICK ANYWHERE ON THE GROUND!";
        instructions.color = "#fff000"
        instructions.fontFamily = "Roboto";
        instructions.fontSize = 24;
        instructions.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        instructions.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
        instructions.paddingBottom = "10px";
        //advancedTexture.addControl(instructions);

        // back to menu button
        const button = GUI.Button.CreateSimpleButton("back", "LEAVE");
        button.width = "100px";
        button.height = "50px";
        button.fontFamily = "Roboto";
        button.thickness = 0;
        button.color = "#f8f8f8";
        button.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
        button.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        button.paddingTop = "10px";
        button.paddingRight = "10px";
        button.onPointerClickObservable.add(async () => {
            console.log('pointer click leave')
            await this.room.leave(true);
        });

        this.advancedTexture.addControl(button);
    }

    loadGltf(scene: BABYLON.Scene) {
        BABYLON.SceneLoader.Append("scenes/", "scene.gltf", scene, function (scene) {
            console.log('gltf scene loaded')
        });
    }

    async bootstrap(): Promise<void> {
        (BABYLON.ArcRotateCamera.prototype as any).spinTo = function (whichprop, targetval, speed) {
            var ease = new BABYLON.CubicEase();
            ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
	        BABYLON.Animation.CreateAndStartAnimation('at4', this, whichprop, speed, 120, this[whichprop], targetval, 0, ease);
        }
        this.scene = new BABYLON.Scene(this.engine);
        this.scene.clearColor = new BABYLON.Color4(0,0,0,0);
        this.light = new BABYLON.HemisphericLight("pointLight", new BABYLON.Vector3(), this.scene);
        const to = new Vector3(0, -300, -100);
        this.camera = new BABYLON.ArcRotateCamera("camera", Math.PI / 2, 1, 600, to, this.scene);
        this.camera.setTarget(BABYLON.Vector3.Zero());
        this.camera.angularSensibilityY = 3000;
        this.camera.angularSensibilityX = 3000;
        let canvas = document.getElementById('renderCanvas')
        this.camera.attachControl(canvas, true);

        createSkyBox(this.scene, this.style);
        this.createGround();
        this.displayGameControls();
        this.initPlayers();
        this.initAudio();
        //await this.joinAudio();
        //await this.scene.whenReadyAsync();

        // The CSS object will follow this mesh
        var plane = BABYLON.MeshBuilder.CreatePlane("iframe", {width: 500, height: 500}, this.scene);
        plane.rotation.y = Math.PI;
        plane.position.z = -200 - this.yoffset;
        plane.position.y = 0;
        plane.checkCollisions = true

        // Setup the CSS renderer and Youtube object
        let renderer = setupRenderer();
        const iframeWidth = 900;
        const iframeHeight = 900;
        createCSSobject(plane, this.scene, renderer, iframeWidth, iframeHeight);
        createMaskingScreen(plane, this.scene, this.engine)

        var listener = (evt) => {
            let pick = this.scene.pick(Math.round(evt.offsetX), Math.round(evt.offsetY));
            if (pick.hit) {
                if (pick.pickedMesh.name === "iframe") {
                    if (!iframeFocused) {
                        iframeFocused = true
                        console.log("iframe")
                        document.getElementsByTagName('body')[0].style.pointerEvents = 'none'
                    }
                }
            }
        }

        // window.addEventListener('pointermove', listener);
        // window.addEventListener('pointerdown', listener);
        window.addEventListener('pointerup', listener);

        this.scene.onPointerDown = (event, pointer) => {
            if (event.button == 2) {
                const targetPosition = pointer.pickedPoint.clone();

                // Position adjustments for the current play ground.
                targetPosition.y = -1;
                if (targetPosition.x > GROUND_BOUNDS) targetPosition.x = GROUND_BOUNDS;
                else if (targetPosition.x < -GROUND_BOUNDS) targetPosition.x = -GROUND_BOUNDS;
                if (targetPosition.z > GROUND_BOUNDS) targetPosition.z = GROUND_BOUNDS;
                else if (targetPosition.z < -GROUND_BOUNDS) targetPosition.z = -GROUND_BOUNDS;

                this.playerNextPosition[this.room.sessionId] = targetPosition;

                // Send position update to the server
                this.room.send("updatePosition", {
                    x: targetPosition.x,
                    y: targetPosition.y - this.yoffset,
                    z: targetPosition.z,
                });
            }
        };

        this.setIframeSrc();
        this.doRender();
    }

    private async gotoMenu() {
        location.reload()
        //this.scene.dispose();
        //await this.leaveAudio();
        //const menu = new Menu('renderCanvas');
        //menu.createMenu();
    }

    private doRender(): void {
        // constantly lerp players
        this.scene.registerBeforeRender(() => {
            for (let sessionId in this.playerEntities) {
              const entity = this.playerEntities[sessionId];
              const targetPosition = this.playerNextPosition[sessionId];
              entity.position = BABYLON.Vector3.Lerp(entity.position, targetPosition, 0.05);
            }
        });

        // Run the render loop.
        this.engine.runRenderLoop(() => {
            this.fps.text= `FPS: ${this.engine.getFps().toFixed()}`;
            this.scene.render();
        });

        // The canvas/window resize event handler.
        window.addEventListener('resize', () => {
            this.engine.resize();
        });
    }
}
